import React from 'react';
import { Col, Container, Row } from '@si-armes/dsfr-react';
import { API_GET_VISUALISER_DOCUMENT_UTILISATEUR } from '../../../constants/apiUrls.constants';
import AffichageResponsive from '../../../components/Commun/AffichageResponsive';
import BoutonPdfTelechargeable from '../../../components/Commun/Fichier/BoutonPdfTelechargeable';

const GuideUtilisateurSIA = () => {
    const nomFichier = 'document_manuel_aide_detenteur.pdf';
    const urlFichier =
        process.env.REACT_APP_API_DETENTEURS_URL +
        API_GET_VISUALISER_DOCUMENT_UTILISATEUR.concat(nomFichier);
    return (
        <>
            <AffichageResponsive
                composantDesktop={
                    <iframe title="Guide utilisateur SIA" className="iframe" src={urlFichier} />
                }
                composantMobile={
                    <Container>
                        <Row className="margin-top-lg">
                            <Col col={12}>
                                <BoutonPdfTelechargeable
                                    urlFichier={urlFichier}
                                    label="Télécharger le manuel d'aide"
                                    titreFichier={nomFichier}
                                />
                            </Col>
                        </Row>
                    </Container>
                }
                pointDeRupture="lg"
            />
        </>
    );
};

export default GuideUtilisateurSIA;
